import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Importation des composants
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Dashboard from './components/Dashboard';
import UnitDetail from './components/UnitDetail';
import AddUnit from './components/AddUnit';
import Organization from './components/Organization';
import LostPassword from './components/LostPassword';
import ResetPassword from './components/ResetPassword'; // Importer le composant ResetPassword
import LegalGate from './components/LegalGate';
import { AuthService } from './services/api';

// Composant pour les routes protégées
const ProtectedRoute = ({ children }) => {

  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/signin" />;
  }
  return <LegalGate>{children}</LegalGate>;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Route par défaut - redirige vers la connexion */}
          <Route path="/" element={<Navigate to="/signin" />} />

          {/* Routes d'authentification */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/lost-password" element={<LostPassword />} />
          <Route path="/reset_password" element={<ResetPassword />} /> {/* CORRIGÉ: Utilisation de l'underscore pour correspondre au lien */}

          {/* Routes protégées */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Route pour les détails d'une unité */}
          <Route path="/unit/:id" element={
            <ProtectedRoute>
              <UnitDetail />
            </ProtectedRoute>
          } />

          <Route path="/add-unit" element={
            <ProtectedRoute>
              <AddUnit />
            </ProtectedRoute>
          } />

          <Route path="/organization" element={
            <ProtectedRoute>
              <Organization />
            </ProtectedRoute>
          } />

          {/* Route 404 - redirige vers la connexion */}
          <Route path="*" element={<Navigate to="/signin" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
